export default "__VITE_ASSET__CUFMf9Zn__"